import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Button from 'components/Button';
import { Row, Col } from 'antd';
import Img from 'gatsby-image/withIEPolyfill';
import Ticker from 'react-ticker';
import { FeaturedContentHeroWrapper, FeatureCategoryText } from '../styles';

const FeaturedContent = ({ image, headingKicker, title, description, ctaLink, ctaLabel }) => {
  const [cardHover, setCardHover] = useState(false);
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (typeof window === 'object') {
      setMobile(window.innerWidth <= 576);
    }
  }, []);

  const isTextMoving = headingKicker && headingKicker.length > 28 && (cardHover || isMobile);

  return (
    <FeaturedContentHeroWrapper
      onMouseEnter={() => {
        setCardHover(true);
      }}
      onMouseLeave={() => {
        setCardHover(false);
      }}
    >
      <Row className="toolbox--hero-row" gutter={{ xs: 0, md: 80 }}>
        <Col lg={{ span: 8 }} md={{ span: 10 }} className="content-panel">
          {isTextMoving ? (
            <Ticker mode={'await'} speed={3}>
              {() => <FeatureCategoryText isHovering={true}>{headingKicker}</FeatureCategoryText>}
            </Ticker>
          ) : (
            <FeatureCategoryText>{headingKicker}</FeatureCategoryText>
          )}
          <a href={ctaLink}>
            <h3 className="hero-title">{title}</h3>
            <p className="hero-text">{description}</p>
            <Button type="primary" to={ctaLink} className="cta-button">
              {ctaLabel}
            </Button>
          </a>
        </Col>
        <Col lg={{ span: 16 }} md={{ span: 14 }} className="toolbox--hero-image">
          <a href={ctaLink}>{image.src && <Img fluid={image.src.fluid} alt={image.alt} />}</a>
        </Col>
      </Row>
    </FeaturedContentHeroWrapper>
  );
};

export default FeaturedContent;
